var __jsx = React.createElement;
import React from "react";
import RequirementItem from "./RequirementItem";
var RequirementsSection = function RequirementsSection(_ref) {
  var title = _ref.title,
    requirements = _ref.requirements;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3 md:w-1/2"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "text-primary-old text-sm font-bold text-start md:text-base"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-1.5 h-full"
  }, requirements === null || requirements === void 0 ? void 0 : requirements.map(function (item) {
    return /*#__PURE__*/React.createElement(RequirementItem, {
      key: item.id,
      item: item
    });
  })));
};
export default RequirementsSection;